import React from 'react';

export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 219.152 219.152">
        <g>
            <path d="M211.652,0H7.501c-4.143,0-7.5,3.358-7.5,7.5v204.152c0,4.143,3.357,7.5,7.5,7.5h204.151c4.143,0,7.5-3.357,7.5-7.5V7.5
            C219.152,3.358,215.794,0,211.652,0z M204.152,204.152H15V15h189.151V204.152z"
            ></path>
            <path d="M58.539,66.038h102.075c4.143,0,7.5-3.357,7.5-7.5s-3.357-7.5-7.5-7.5H58.539c-4.143,0-7.5,3.357-7.5,7.5
            S54.396,66.038,58.539,66.038z"
            ></path>
            <path d="M58.539,117.076h102.075c4.143,0,7.5-3.357,7.5-7.5s-3.357-7.5-7.5-7.5H58.539c-4.143,0-7.5,3.357-7.5,7.5
            S54.396,117.076,58.539,117.076z"
            ></path>
            <path d="M58.539,168.114h102.075c4.143,0,7.5-3.357,7.5-7.5c0-4.143-3.357-7.5-7.5-7.5H58.539c-4.143,0-7.5,3.357-7.5,7.5
            C51.039,164.757,54.396,168.114,58.539,168.114z"
            ></path>
        </g>
    </svg>
);
